/**
 * In-app destinations for push notification taps (mobile app routes).
 * Values are stored as action_url on the backend — admins pick a label only.
 */
export const APP_SCREEN_LINKS = [
  { value: "", label: "No link — notification only" },
  { value: "/home", label: "Home" },
  { value: "/daily-quiz", label: "Daily quiz" },
  { value: "/all-courses", label: "Courses" },
  { value: "/notifications", label: "Notifications inbox" },
  { value: "/certificate", label: "My certificates" },
  { value: "/reports", label: "My reports" },
  { value: "/settings", label: "Settings" },
  { value: "/help", label: "Help guide" },
  { value: "/privacy-policy", label: "Privacy policy" },
  { value: "/terms-of-service", label: "Terms of service" },
  { value: "/about-us", label: "About us" },
];

export function appScreenLabel(path) {
  if (!path) return "None";
  const match = APP_SCREEN_LINKS.find((l) => l.value === path);
  return match?.label || path;
}
